// extracted by mini-css-extract-plugin
module.exports = {"confetti-background":"confetti-background--a6cdd","confettiBackground":"confetti-background--a6cdd"};